import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useContext, useState } from 'react';
import { Button, Card, Container, Form } from 'react-bootstrap';
import { addDoc, collection } from 'firebase/firestore';
import Swal from 'sweetalert2';

import { AppContext } from '../../../../Context';
import { db } from '../../../../firebase/firebase';

const textoPeriodismo = `GÉNEROS Y MODALIDADES DEL PERIODISMO TELEVISADO

El periodismo televisado comprende tanto la transmisión de noticias como un espacio periódico o avances especiales fuera de hora, el comentario a modo editorial, las revistas de prensa o programas de panel, los “magazines” de actualidad o las “revistas de noticias” y, por supuesto, las transmisiones directas de acontecimientos políticos que entran en la categoría de noticias.

En el periodismo televisado hay géneros que pertenecen al periodismo informativo y otros que entran en las categorías del periodismo interpretativo o de análisis. Los noticieros y avances pertenecen a la primera categoría, mientras que los programas de panel y las revistas de noticias pertenecen a la segunda.

En una edición de un noticiero de televisión hay dos modalidades de subgéneros de información: la noticia simple y el reportaje. En la primera, el locutor resume el hecho y presenta al protagonista; además, puede añadir algunos datos previos. La segunda aporta datos, sobre todo gráficos, acerca del tema y permite al receptor entrar en contacto con lo que sucede y con los personajes principales. Dentro del reportaje existen modalidades como el habitual o de actualidad, el de análisis, la biografía o semblanza, la entrevista y la encuesta.

Cada modalidad del periodismo televisado tiene su formato externo y su estilo. Las noticias deben poseer un ritmo acorde con su urgencia y novedad. Los programas de análisis o interpretación deben ser más lentos, para que el espectador pueda adentrarse en el problema, conocer a los participantes y captar los antecedentes históricos, sociológicos, económicos o políticos.`;

const preguntas5W = [
    { id: 'que', etiqueta: '¿Qué explica principalmente el texto?' },
    { id: 'quien', etiqueta: '¿Quiénes participan o intervienen en estas modalidades?' },
    { id: 'cuando', etiqueta: '¿Cuándo se utiliza cada ritmo o formato?' },
    { id: 'donde', etiqueta: '¿Dónde se presentan estos géneros periodísticos?' },
    { id: 'porQue', etiqueta: '¿Por qué cambia el ritmo entre noticias y programas de análisis?' }
];

const M15_MetodoLectura = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    const [enviando, setEnviando] = useState(false);
    const [respuestas, setRespuestas] = useState({
        prediccion: '',
        investigacion: '',
        tecnicaAplicada: '',
        preguntas5W: { que: '', quien: '', cuando: '', donde: '', porQue: '' },
        asimilacion: ''
    });

    const actualizarCampo = (campo, valor) => setRespuestas(prev => ({ ...prev, [campo]: valor }));
    const actualizar5W = (campo, valor) => setRespuestas(prev => ({
        ...prev,
        preguntas5W: { ...prev.preguntas5W, [campo]: valor }
    }));

    const avanzar = (campos) => {
        if (!modoConsulta && (campos.some(campo => !respuestas[campo].trim()))) {
            Swal.fire({ icon: 'warning', title: 'Etapa incompleta', text: 'Completa la respuesta antes de continuar.' });
            return;
        }
        setStep(prev => prev + 1);
    };

    const avanzar5W = () => {
        if (!modoConsulta && (Object.values(respuestas.preguntas5W).some(valor => !valor.trim()))) {
            Swal.fire({ icon: 'warning', title: 'Preguntas incompletas', text: 'Responde las cinco preguntas antes de continuar.' });
            return;
        }
        setStep(5);
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        if (!respuestas.asimilacion.trim()) {
            Swal.fire({ icon: 'warning', title: 'Asimilación incompleta', text: 'Escribe tu síntesis o conclusión final.' });
            return;
        }
        setEnviando(true);
        try {
            await addDoc(collection(db, 'evaluaciones'), {
                userId: currentUser.uid,
                nombre: 'Método de lectura aplicado',
                nivel: 'Avanzado',
                modulo: '15',
                createdAt: new Date(),
                tipo: 'Método completo de lectura',
                lectura: 'Géneros y modalidades del periodismo televisado',
                respuestas
            });
            await Swal.fire({ title: '¡Ejercicio completado!', text: 'El método aplicado se guardó correctamente.', icon: 'success', confirmButtonText: 'Continuar' });
            if (cerrarModal) cerrarModal();
        } catch (error) {
            console.error('Error al guardar el ejercicio:', error);
            Swal.fire({ icon: 'error', title: 'No se pudo guardar', text: 'Intenta enviar nuevamente el ejercicio.' });
        } finally {
            setEnviando(false);
        }
    };

    return (
        <Container>
            <h3 className="text-center mb-2">Pongamos su método en práctica</h3>
            <p className="text-center text-muted mb-4">Géneros y modalidades del periodismo televisado</p>

            {step === 1 && (
                <div>
                    <Card className="mb-4 shadow-sm"><Card.Body>
                        <Card.Title>1. Prediga</Card.Title>
                        <Card.Text>Observa únicamente el título e infiere de qué tratará la lectura.</Card.Text>
                    </Card.Body></Card>
                    <Form.Group className="mb-4">
                        <Form.Label>Tu predicción</Form.Label>
                        <Form.Control as="textarea" rows={4} name="prediccion" value={respuestas.prediccion} onChange={e => actualizarCampo('prediccion', e.target.value)} />
                    </Form.Group>
                    <div className="d-flex justify-content-end"><Button onClick={() => avanzar(['prediccion'])}>Siguiente</Button></div>
                </div>
            )}

            {step === 2 && (
                <div>
                    <Card className="mb-4 shadow-sm"><Card.Body>
                        <Card.Title>2. Investigue</Card.Title>
                        <Card.Text>Haz un salteo general del texto y registra la idea que obtuviste sin leerlo todavía en profundidad.</Card.Text>
                        <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>{textoPeriodismo}</div>
                    </Card.Body></Card>
                    <Form.Group className="mb-4">
                        <Form.Label>Idea general obtenida</Form.Label>
                        <Form.Control as="textarea" rows={4} name="investigacion" value={respuestas.investigacion} onChange={e => actualizarCampo('investigacion', e.target.value)} />
                    </Form.Group>
                    <div className="d-flex justify-content-between"><Button variant="secondary" onClick={() => setStep(1)}>Atrás</Button><Button onClick={() => avanzar(['investigacion'])}>Siguiente</Button></div>
                </div>
            )}

            {step === 3 && (
                <div>
                    <Card className="mb-4 shadow-sm"><Card.Body>
                        <Card.Title>3. Aplique su técnica de lectura</Card.Title>
                        <Card.Text>Lee en profundidad con la técnica de tu preferencia y explica cómo organizaste la información.</Card.Text>
                        <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>{textoPeriodismo}</div>
                    </Card.Body></Card>
                    <Form.Group className="mb-4">
                        <Form.Label>Análisis de la lectura</Form.Label>
                        <Form.Control as="textarea" rows={5} name="tecnicaAplicada" value={respuestas.tecnicaAplicada} onChange={e => actualizarCampo('tecnicaAplicada', e.target.value)} />
                    </Form.Group>
                    <div className="d-flex justify-content-between"><Button variant="secondary" onClick={() => setStep(2)}>Atrás</Button><Button onClick={() => avanzar(['tecnicaAplicada'])}>Siguiente</Button></div>
                </div>
            )}

            {step === 4 && (
                <div>
                    <Card className="mb-4 shadow-sm"><Card.Body><Card.Title>4. Pregúntese: las 5 W</Card.Title><Card.Text>Interroga el contenido para comprobar tu comprensión.</Card.Text></Card.Body></Card>
                    {preguntas5W.map(pregunta => (
                        <Form.Group className="mb-3" key={pregunta.id}>
                            <Form.Label>{pregunta.etiqueta}</Form.Label>
                            <Form.Control name={pregunta.id} value={respuestas.preguntas5W[pregunta.id]} onChange={e => actualizar5W(pregunta.id, e.target.value)} />
                        </Form.Group>
                    ))}
                    <div className="d-flex justify-content-between"><Button variant="secondary" onClick={() => setStep(3)}>Atrás</Button><Button onClick={avanzar5W}>Siguiente</Button></div>
                </div>
            )}

            {step === 5 && (
                <div>
                    <Card className="mb-4 shadow-sm border-success"><Card.Body><Card.Title>5. Asimile</Card.Title><Card.Text>Resume, adapta y concluye con tus propias palabras.</Card.Text></Card.Body></Card>
                    <Form.Group className="mb-4">
                        <Form.Label>Síntesis o conclusión final</Form.Label>
                        <Form.Control as="textarea" rows={6} name="asimilacion" value={respuestas.asimilacion} onChange={e => actualizarCampo('asimilacion', e.target.value)} />
                    </Form.Group>
                    <div className="d-flex justify-content-between"><Button variant="secondary" onClick={() => setStep(4)}>Atrás</Button><Button variant="success" disabled={enviando} onClick={enviarResultados}>{enviando ? 'Guardando…' : 'Finalizar y enviar'}</Button></div>
                </div>
            )}
        </Container>
    );
};

export default M15_MetodoLectura;
